import { Builder } from '@builder.io/react'
import React from 'react'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'

interface Props {
  backgroundColor: string
  videoOutline: string
  heroImage: string
  heroImgAltText: string
  signatureTextEnabled: boolean
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
  description: string
  signature: string
  imageHeadText: string
  imageFooterText: string
}

const HeroFive = ({
  backgroundColor,
  videoOutline,
  signatureTextEnabled,
  buttonEnabled,
  buttonProp,
  heroImage,
  heroImgAltText = '',
  description,
  signature,
  imageHeadText,
  imageFooterText
}: Props) => {
  const renderCTAButton = () => {
    if (buttonEnabled) {
      return (
        <LinkButton
          buttonColor={buttonProp?.buttonColor}
          buttonText={buttonProp?.buttonText}
          buttonTextColor={buttonProp?.buttonTextColor}
          loggedInButtonText={buttonProp?.loggedInButtonText}
          buttonUrl={buttonProp?.buttonUrl}
          isLink={buttonProp?.isLink}
          classList={
            'mt-4 mx-auto w-full md:w-8/12 flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-indigo-700 bg-indigo-100 hover:bg-indigo-200 md:text-lg'
          }
        />
      )
    }

    return null
  }

  return (
    <div className="relative w-full bg-[#FAEAD8] lg:-mt-12 lg:pt-12" style={{ backgroundColor }}>
      <div className="container mx-auto flex w-full flex-col items-center justify-center gap-6 px-8 py-5 md:flex-row md:gap-12">
        <div className="w-full md:w-[50%]">
          <h1>
            <span className="relative top-4 text-4xl font-medium text-[#006685] lg:text-5xl xl:text-7xl">
              {imageHeadText}
            </span>
            <div className="bg-[#EDB97E] py-2 pl-2 pr-1" style={{ backgroundColor: videoOutline }}>
              <img className="h-full w-full object-contain" src={heroImage} alt={heroImgAltText} />
            </div>
            <span className="relative bottom-2 text-right text-4xl font-medium text-[#006685] lg:text-5xl xl:text-7xl">
              {imageFooterText}
            </span>
          </h1>
        </div>
        <div className="w-full md:w-1/2 md:max-w-lg">
          <div className="font-sans text-lg font-medium text-black md:text-2xl lg:text-2xl pt-14">{description}</div>
          {signatureTextEnabled && signature.length ? (
            <div className="font-third my-5 text-3xl text-black sm:text-4xl">{signature}</div>
          ) : (
            ''
          )}
          {renderCTAButton()}
        </div>
      </div>
    </div>
  )
}

export default HeroFive

Builder.registerComponent(HeroFive, {
  name: 'HeroFive',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#FAEAD8'
    },
    {
      name: 'videoOutline',
      type: 'color',
      defaultValue: '#EDB97E'
    },
    {
      name: 'heroImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroImgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageHeadText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageFooterText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'description',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'signatureTextEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'signature',
      type: 'text',
      defaultValue: ''
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    }
  ]
})
